import stopWords from './stopWords'

const setUpperCase = (texto) => {
  return texto.toUpperCase()
}

const capitalizeFirstLetter = (texto) => {
  // split the above string into an array of strings
  // whenever a blank space is encountered
  const palavras = texto.toLowerCase().split(' ')

  // loop through each element of the array and capitalize the first letter.
  const tam = palavras.length
  for (let i = 0; i < tam; i++) {
    if (!stopWords.includes(palavras[i])) {
      palavras[i] = palavras[i].charAt(0).toUpperCase() + palavras[i].slice(1)
    }
  }

  const formatedText = palavras.join(' ')
  return formatedText
}

const applyTextFormat = (text = '', type) => {
  let formatedText = text
  switch (type) {
    case 1: {
      formatedText = setUpperCase(formatedText)
      break
    }
    case 2: {
      formatedText = capitalizeFirstLetter(formatedText)
      break
    }
    default: {
      break
    }
  }
  return formatedText
}

export { applyTextFormat }
